import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as SurchargeInstruction[] | null;

const slice = createSlice({
  name: '$bufferOrderingProviderSurchargeInstructions',
  initialState,
  reducers: {
    setBufferOrderingProviderSurchargeInstructions(
      state,
      action: PayloadAction<SurchargeInstruction[] | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setBufferOrderingProviderSurchargeInstructions } = slice.actions;
export default slice.reducer;
